export default "__VITE_ASSET__BujX6V$B__"